<template>
  <nav class="navbar navbar-expand-lg fixed-top">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between w-100">
        <div class="col-3">
            <a class="navbar-brand" @click="$router.push({name: 'user.dashboard'})">
                <img
                    class="logo"
                    alt=""
                    v-if="logoPath"
                    :src="logoPath"
                />
                <img
                    class="logo"
                    src="@/assets/images/logo.png"
                    alt=""
                    v-else
                />
            </a>
        </div>
        <div class="col-3">
            <button
                v-if="isLoggedIn"
                class="btn btn-warning btn-sm btn-block w-50"
                style="margin: 0 0 0 auto"
                @click="$store.dispatch('user/logout')"
            >LOGOUT</button>
        </div>
        <header-progress-bar class="ml-5" v-if="showProgressBar"></header-progress-bar>
      </div>
    </div>
  </nav>
</template>

<script>
    import HeaderProgressBar from './HeaderProgressBar';

    export default {
        name: 'SiteHeader',

        data() {
            return {
                logo: ''
            };
        },

        computed: {
            logoPath() {
                return this.$store.state.app.logoPath;
            },
            showProgressBar () {
                return this.$store.getters['header/progressShow'];
            },
            isLoggedIn() {
                return this.$store.getters['user/isLoggedIn'];
            }
        },

        mounted() {
            this.$store.dispatch('app/getLogo');
        },

        components: {
            HeaderProgressBar
        },
    };
</script>
